import React from "react";

const VideoCTA = ({ videoSrc, title, subtitle, desc }) => {
  return (
    <section className="vid-cta-section">
      <video autoPlay muted loop playsInline className="background-video">
        <source src={videoSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="overlay"></div>
      <div className="cta-content">
        <h2>Transform Your Water. <br/>Transform Your Life.</h2>
        <p className="desc">{desc}</p>
        <div className="cta-buttons">
          <a href="tel:1300631226">
            <button className="btn primary">Call Now</button>
          </a>
          <a href="#contact-section">
            <button className="btn secondary">Contact Us</button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default VideoCTA;
